/**
 * Created by Arif Topcu in 2019
 */

import React, { useCallback } from "react";
import styles from "./DurationRelativeToTargetSelector.module.css";
import ComplicationMiniSelector from "components/ComplicationMiniSelector2";
import { setDefinition } from "state/durationToTarget/actions";
import DurationToTargetDefinition from "state/durationToTarget/DurationToTargetDefinition";
import Combobox from "@ls/react-combobox-grid";
import { summaryTypeOptionsLegacy } from "state/selections/Constants/SummaryType";
import { selectDefinitions } from "state/durationToTarget/selectors";
import SelectionState from "state/selections/SelectionState";
import { useSelector } from "react-redux";

const DurationRelativeToTargetComplication = ({
  definition,
  setDefinition,
}) => {
  const onChange = useCallback(
    (value) => setDefinition(definition.setSummary(value)),
    [setDefinition, definition]
  );
  return (
    <div className={styles.root}>
      <div className={styles.selector}>
        <Combobox
          options={summaryTypeOptionsLegacy}
          value={definition.summary}
          onChange={onChange}
          label="Abs/Rel:"
          clearable={false}
          variation={0}
          size={"S"}
          gridHeight={100}
        />
      </div>
    </div>
  );
};

const DurationRelativeToTargetSelector = () => {
  const definitions = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  );

  return (
    <ComplicationMiniSelector
      definitions={definitions}
      setDefinition={setDefinition}
      getDefaultDefinition={DurationToTargetDefinition.getDefault}
      Complication={DurationRelativeToTargetComplication}
      btnTitle="Duration Relative to Target"
      single
    />
  );
};

export default DurationRelativeToTargetSelector;
